export default {
  'spotting-scq': {
    'course-title': 'More practice in seeing the SCQ Structure',
    'course-name': 'Section 4B-2 <span class="unit-title">More practice in seeing the SCQ Structure<span>',
    'course-video': {
      'title': 'Section 4 BUILDING A PYRAMID<br/>1’24:58 – 1’32.42  4B-1 HOW TO DEVELOP AN INTRODUCTION   :<br/>- 4B-1  Determining The Readers Questions',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': '4B-2 Lecture'
    },
    'unit-section-title': '<span>4B-2</span> Give a quick insight into the question you wish to answer in the reader’s mind',
    'unit-intro-title': '4B-2 Exercises',
    'exercise-intro': `
    As you have seen, the secret to producing clear documents is to organize your material to answer a question that already exists in the reader’s mind – or would exist or should exist if he thought for a minute about what he already knows.  And then to write the introduction so that it reminds him of his question.  You have also seen that the patterns of introduction for business documents tend to focus on one of three types of question, as shown below.<br><br>
    <div class="documents-standard">
        <span>Basic Pattern</span>
        <span>Illustration</span>
    </div>
    <div class="documents-show-row">
        <div class="documents-show-element">
            <span class="documents-show-element__title">What should we do?</span>
            <div class="documents-show-element__scq">
                <span>S = Want to do X</span>
                <span>C = Have problem</span>
                <span>Q = What do?</span>
            </div>
        </div>
        <div class="documents-show-element">
            <span class="documents-show-element__title">The Role of the Board</span>
            <div class="documents-show-element__scq">
                <span>S = Board now free to deal entirely with broad matters of policy and planning</span>
                <span>C = Not set up to do so?</span>
                <span>Q = What do?</span>
            </div>
        </div>
    </div>
    <div class="documents-show-row">
        <div class="documents-show-element">
            <span class="documents-show-element__title">Should we/can we do it?</span>
            <div class="documents-show-element__scq">
                <span>A = Will face a problem</span>
                <span>C = Know the solution</span>
                <span>Q = Can they implement it?</span>
            </div>
        </div>
        <div class="documents-show-element">
            <span class="documents-show-element__title">Black Holes</span>
            <div class="documents-show-element__scq">
                <span>S = When the sun fails, humans will turn to the energy of the visible universe, and exhaust it</span>
                <span>C = Only remaining store of energy will be black holes</span>
                <span>Q = Will they be able to access one?</span>
            </div>
        </div>
    </div>
    <div class="documents-show-row">
        <div class="documents-show-element">
            <span class="documents-show-element__title">How should we do it?</span>
            <div class="documents-show-element__scq">
                <span>S = Did X to achieve Y</span>
                <span>C = Doesn’t work</span>
                <span>Q = How fix?</span>
            </div>
        </div>
        <div class="documents-show-element">
            <span class="documents-show-element__title">The Optimal Office</span>
            <div class="documents-show-element__scq">
                <span>S = Open plan office sought to boost communication and efficiency</span>
                <span>C = Employees disliked it one very aspect measured</span>
                <span>Q = How fix?</span>
            </div>
        </div>
    </div>
    <br/>
    Here is a shorter summary of the basic patterns, which I will ask you to identify in the exercises that follow.
    <br/><br/>

    <div class="complication-question">
        <div class="complication-question__row">
            <div class="complication-question__element">
                <span class="complication-question__title">complication</span>
            </div>
            <div class="complication-question__element">
                <span class="complication-question__title">question</span>
            </div>
        </div>
        <div class="complication-question__row">
            <div class="complication-question__element">
                <span>A. A problem occurred/could occur</span>
            </div>
            <div class="complication-question__element">
                <span>Can we solve it?</span>
                <span>What action should we take to solve it?</span>
            </div>
        </div>
        <div class="complication-question__row">
            <div class="complication-question__element">
                <span>B. An action is/could be required</span>
                <span>An action taken has not worked</span>
            </div>
            <div class="complication-question__element">
                <span>How should we do it?</span>
                <span>How should we have done it?</span>
            </div>
        </div>
        <div class="complication-question__row">
            <div class="complication-question__element">
                <span>C. An action has been suggested</span>
                <span>A suggested action must meet certain criteria</span>
                <span>A logical conclusion has been/could be drawn</span>
            </div>
            <div class="complication-question__element">
                <span>Is it the right action?</span>
                <span>Does it meet the criteria?</span>
                <span>Is it the right conclusion?</span>
            </div>
        </div>
        <div class="complication-question__row">
            <div class="complication-question__element">
                <span>D. Alternative actions are possible</span>
            </div>
            <div class="complication-question__element">
                <span>Which action makes most sense?</span>
            </div>
        </div>
    </div>
    <br/><br/>
    In each case, you will need to read an introductory paragraph plus my statement of the essence of what it says.  Then I show the simplest statement of its corresponding Situation-Complication and Question, and ask you to place them to their proper position in the introduction.
    <br/><br/>
    The exercises are meant to demonstrate how forcing yourself to see the bare bones of the introduction can:
    <br/>
    `,
    'menu-list': {
      'exercise-1': 'Whom Can You Trust?',
      'exercise-2': 'What we had?',
      'exercise-3': 'Entrepreneurs',
      'exercise-4': 'Creativity as Theft',
      'exercise-5': 'Is Your Budget Stuck on Last Year’s Numbers?',
      'exercise-6': 'Going Slow to Go Fast',
      'exercise-7': 'Marketing Myopia',
      'exercise-8': 'Who Killed Pensions?',
      'exercise-9': 'Epic Fails of the Start-up World',
      'exercise-10': 'The TV Decline',
      'exercise-11': 'Honour on the Campus',
      'exercise-12': 'A Survey of IFA Attitudes',
      'first-part': 'Give a quick insight into the question you wish to answer in the reader’s mind',
      'second-part': 'Alert you to any problems in your SCQ structure',
      'third-part': 'Help you avoid Why? questions',
      'fourth-part': 'Final Practice',
    },
    'exercise-1': {
      'number': '4B-2 - Exercise 1',
      'title': 'Whom Can You Trust?',
      'description': `
      Imagine that you’re negotiating a multiyear deal to provide outsourcing services to a large company.  The client tells you that her firm wants to sign on for a certain level of services, but she’d like you to be willing to deliver more on the fly, trusting that you’ll be able to work out terms for the additional resources as the need arises.  Should you agree?
      Or imagine that a potential business partner wants to buy $12 million worth of services from you, but can spend only $10 million because of temporary budget constraints.  He dangles the prospect of long-term revenue opportunities in exchange for the discount, but says he can’t commit to anything yet.  Should you give him the deal?
      <br><br>
      Situations such as these present dilemmas for any manager.  The answers aren’t obvious.  If you choose to trust new clients, contractors, or collaborators, you make yourself vulnerable:  your outcomes, financial and otherwise, now depend on their fidelity.  But if you insist on verifying each claim and accounting for every detail before a deal is signed, you’ll slow the process and increase costs, potentially putting yourself at a disadvantage.
      Success in business unquestionably requires some willingness to cooperate with and have faith in others.  The question is, how much faith and in whom.
      `,
      'reference': 'David de Steno, Harvard Business Review, <br>March 2014'
    },
    'exercise-2': {
      'number': '4B-2 - Exercise 9',
      'title': 'Epic Fails of the Start-up World',
      'description': `
      We live in an age of the start-up.  It’s never been easier to build a product and start a company.  And, thanks to the boom in angel investing and crowdfunding, it’s never been easier for start-ups to raise money.  The analytics firm CB Insights logged more than seventeen hundred seed-investment deals in the U.S. tech industry in 2012, more than three times the number from three years earlier.
      <br><br>
      But there’s a catch.  Starting a company may be easier, but making a success isn’t.  Competition is fierce, profits are scarce, and venture capitalists aren’t generous when it comes to later stages of financing.  The life of a new company is often brutish and short.
      <br><br>
      The fact that most new businesses fail is hardly a secret.  So why are so many people gambling on ventures that are likely to end badly?
      `,
      'reference': 'James Surowiecki writing on The Financial Page in The New Yorker, <br>May 19, 2014'
    },
    'unit-section-title-2': '<span>4B-2</span> Alert you to any problems in your SCQ structure',
    'unit-section-title-3': '<span>4B-2</span>  Help you avoid Why? questions',
    'unit-section-title-4': '<span>4B-2</span> Final Practice',
    'exercise-3': {
      'intro': `
      Now that you see the general pattern, try yourself to pick out the S-C-Qs in the following introductions, and identify the underlying structures.<br><br>`,
      'intro-list': {
        'left': `
        <b>3. Who Killed Pensions?</b><br>
        <b>4. What We Had?</b><br>
        <b>5. Marketing Myopia</b><br>
        <b>6. The TV Decline</b><br>
        <b>7. Honor on the Campus</b><br>
        `,
        'right': `
        <b>(including the answer in the question)</b><br>
        <b>(questioning received opinion)</b><br>
        <b>(implying parts of the introduction)</b><br>
        <b>(implying parts of the introduction)</b><br>
        <b>(asking an unexpected question)</b>
        `
      },
      'number': '4B-2 - Exercise 8',
      'title': 'Who killed Pensions?',
      'subtitle': '(Including the answer in the question)',
      'description': `
      Who killed pensions? Can they be resurrected? <br>
      A few decades ago, pensions were almost taken for granted by both public and private employees. They promised that people who worked a specified number of years for one employer would receive a certain amount each month, for life, after they retired. That amount was usually based on their income in the years before retirement. Today, pensions are almost dead in corporate America — at least for new employees. They live on in government jobs, sometimes protected by state constitutions. But Detroit’s bankruptcy has put its benefits in doubt after a judge said federal law could override the state Constitution. And given that some states and municipalities appear to have promised more than they can conceivably afford, it seems likely that some of those promises will be broken and that courts will find ways to allow that.
      `
    },
    'exercise-4': {
      'number': '4B-2 - Exercise 2',
      'title': 'What We Had?',
      'subtitle': '(Questioning receiving opinion)',
      'description': `
      Carefully gathered data show that by the mid-1700s, the average income of American colonists measured in terms of purchasing power had already exceeded the average income earned in England. Better diets even made Americans healthier than their Old World counterparts. Revolutionary soldiers, for example, stood three to four inches taller than their British adversaries. Our optimistic, confident sense of ourselves developed in these privileged circumstances, and, as we have seen, American income, though volatile, kept growing rapidly.<br>
      Abundant land on the frontier, natural resources, a thriving domestic trade, and agricultural exports supported in part by slave labor accounted for this unusual prosperity in our early years. But ingrained in most of us, I think, is the oversimplified idea that our exceptional growth since the Civil War has been almost entirely the consequence of the scientific, engineering and technological breakthroughs of the nineteenth century, coupled perhaps with our enterprising attitude and a largely unregulated market economy.<br>
      America had in fact no particular edge over other industrial nations in these areas.
      `
    },
    'exercise-5': {
      'number': '4B-2 - Exercise 7',
      'title': 'Marketing Myopia',
      'subtitle': '(Implying parts of the introduction)',
      'description': `Every major industry was once a growth industry. But some that are now riding a wave of growth enthusiasm are very much in the shadow of decline. Others which are thought of as seasoned growth industries have actually stopped growing. In every case the reason growth is threatened, slowed, or stopped is not because the market is saturated. It is because there has been a failure of management.`
    },
    'exercise-6': {
      'number': '4B-2 - Exercise 10',
      'title': 'The TV Decline',
      'subtitle': '(Implying parts of the introduction)',
      'description': `Something is happening to America. Television viewing is going down. Nielsen said viewing was off by 6.4 percent in the daytime and 3.1 percent at night. We’re talking about millions of people now, and the big question is: Where have these people gone, and what are they doing if they aren’t watching television?`
    },
    'exercise-7': {
      'number': '4B-2 - Exercise 11',
      'title': 'Honor on the Campus',
      'subtitle': '(Asking an unexpected question)',
      'description': `The news from Cambridge, Massachusetts, is that 83 percent of all the undergraduates at MIT cheated at least once in their college careers.  More than two-thirds confessed to plagiarism, and half admitted stealing other people’s ideas.  What puzzled me about the survey was not that 83 percent cheated – but 17 percent didn’t.  I went to the campus to talk to the non-cheaters.`
    },
    'exercise-8': {
      'number': '4B-2 - Exercise 5',
      'title': 'Is Your Budget Stuck in Last Year’s Numbers?',
      'subtitle': '(Failing to identify the problem, making the solution part of the introduction)',
      'description': `
      For many CFOs budget meetings are a long, exhausting process.  The presenters show you their plans, you probably challenge every number, explore every assumption. In the end you may raise their targets a little.  But the budget each unit will have to deliver next year – you have to admit – will not be not very different from the one proposed at the beginning, which in turn is not very different from the latest forecast for this year.
      <br><br>
      What happened? The short answer is, you’ve been anchored.  Anchoring is a well-known psychological bias whereby one piece of information sticks in your mind and influences your interpretation of subsequent information, even if you’re unaware of it.  Studies have shown that even obviously irrelevant numbers can influence estimates.
      <br><br>
      In one study, respondents were asked to estimate the age of Mahatma Gandhi at death. Before they had to answer, half of them were asked if Gandhi was younger or older than 5 when he died; the other half if he was younger or older than 140.  Both questions are ridiculous, and their answers obvious and irrelevant..  Yet the first group, on average, gave estimates of Gandhi’s age at death that were 20 years younger than the second group. If we can be “anchored” by such obviously irrelevant inputs,  getting stuck in the same budget numbers from year to year is almost unavoidable.
      <br><br>
      Many management techniques attempt to overcome this challenge. Zero-based budgeting is one such technique, but it is a time-consuming approach that cannot be used systematically. Another is to ask the “What would it take?” question.  For example, “What would it take to double that rate of growth or achieve the same results with half the resources?” This is a useful technique to force a rethink of assumptions, if used sparingly. But if it becomes a routine that presenters expect, they will only harden their justifications (not to mention that repeatedly asking abstract, annoying questions will make you look disconnected from reality).
      <br><br>
      So what works? An anchor is such a powerful influence that only another anchor can overcome it. Re-anchoring combats the anchor of history and convention with another anchor, grounded in a different set of facts.
      `,
      'reference': 'Dan Lovallo and Olivier Sibony  <br> Harvard Business Review, March 2012'

    },
    'exercise-9': {
      'number': '4B-2 - Exercise 4',
      'title': 'Creativity as Theft',
      'subtitle': '(Using anecdotal information to generate the question)',
      'description': `
      Once, while travelling in the Australian outback, I met an aboriginal man called Sammy who showed me how his tribe made a hafted knife by using a natural sap or pitch to glue sharp pieces of stone to a wooden handle.  I noticed that the way he attached these blades to the handle didn’t seem likely to produce a strong bond, so through an interpreter I asked him why he didn’t do it differently.  He stared at me for a moment and then replied that his tribe had always done it his way.
      <br><br>
      I don’t suggest that I had a better alternative, or that I had spotted a flaw in a piece of cultural technology that Sammy’s tribe might have used for millennia.  There was probably a good reason why his tribe produced the tool as they did.  My point is that Sammy didn’t seem to know what that reason was (or he simply couldn’t be bothered to tell this interloper a tribal secret).
      <br><br>
      There is no reason to think that Sammy is unusual or different.  You are surrounded by objects such as smartphones and microwaves that you don’t know how to make, much less understand how they work.  It is even more stark than this.  In his 1958 essay “I, Pencil,” Leonard Read wrote:  “Not a single person on the face of this Earth knows how to make me.”  And it is true:  to make a pencil you’ll need to know about mining, refining and shaping graphite, and the same for the wood, rubber and metal.  And even then you haven’t made the pencil.
      <br><br>
      The sobering truth is that far from being highly creative and innovative, most of us are just glorified “karaoke singers” in most aspects of our lives, using things others have made.  So how then has our species acquired its technological innovations, progressing from simple hand axes to the iPads and smartphones of today?
      `,
      'reference': 'Creativity, like Evolution, is Merely a Series of Thefts<br>by Mark Pagel,  WIRED, 2014.'
    },
    'exercise-10': {
      'number': '4B-2 - Exercise 6',
      'title': 'Going Slow to Go Fast',
      'subtitle': '(Making the solution part of the introduction)',
      'description': `
      Product life cycles continue to shrink in “fast” industries like fashion and personal computers, where new products roll out the door every few months. Even “slow” industries like steel have quickened their pace. Speed is of the essence — but so are quality and cost. Companies in all sectors know they must deliver on all three dimensions simultaneously.  Yet world-class product development is still by far the exception. Even the most disciplined and creative product development processes can be plagued by schedule slippages, “firefighting,” and inferior quality. Often, the problem is a failure to consider product development as a dynamic whole. <b>Managers try to improve performance by breaking the process apart.</b>
      <br><br>
      But isolated improvement efforts can have a negative effect on performance when they are implemented without regard to the <b>multiple relationships that drive the product development process.</b>  Setting aggressive commercialization schedules, for example, often has just the opposite effect of what was intended: namely, longer delays with lower quality. And many other cherished management beliefs, such as “lean and mean” staffing, can also inadvertently contribute to product development problems.  What’s needed instead is an integrated, holistic approach that captures product development as a complex system.

      `,
      'reference': 'Creativity, like Evolution, is Merely a Series of Thefts<br>by Mark Pagel,  WIRED, 2014.'
    },
    'exercise-11': {
      'number': '4B-2 - Exercise 3',
      'title': 'Entrepreneurs',
      'description': `Two common notions shape our views about entrepreneurs, and neither is quite right.  One of them imagines that they craft careful business plans and execute them skillfully.  In fact, most new businesses don’t adhere to a script.  They adapt and modify as they go along, learning from feedback and trying new things.
        <br/>
        The other sees entrepreneurs as slightly wacky, possessed by extraordinary self-belief and willing to take a bet with very long odds.  They exhibit common cognitive biases that are often associated with bad decisions, but are useful when it comes to starting a new business.  This view, currently in vogue, isn’t right either.
        <br>
        The truth is less surprising but no less impressive.  Successful entrepreneurs display a blend of seemingly contradictory skills.  They combine careful analytical thinking – what we associate with the left brain – and a willingness to push boundaries – what we call “the right stuff.”`
    },
    'paper-header': `
            <div>
              <p>TO:</p>
              <p>FROM:</p>
            </div>
            <div>
              <p>DATE:</p>
              <p>SUBJECT: A Survey of IFA Attitudes and Views</p>
            </div>`,
    'exercise-12': {
      'number': '4B-2 - Exercise 12',
      'title': 'A Survey of IFA Attitudes and Views',
      'description': `<p>Assume you have a client (AMP) who wants to buy a life and pensions provider called Thynne, as a means of entering the life and pensions market. Since Thynne is not well thought of in the market, and consequently not doing well, AMP has the opportunity to acquire the company at a low price, with the thought of turning it around. Turning it around would require getting it recommended by the body of Independent Financial Advisors, who currently ignore it. Your client has asked you to conduct research to find out:</p>
      <ul class="bullet-list">
        <li>How Independent Financial Advisors select life and pensions providers</li>
        <li>Which companies they prefer</li>
        <li>Their views on developments at Thynne and other mutuals</li>
        <li>Their attitudes towards potential acquirers</li>
      </ul>
      <p>Here is the report you have written. You will see at once that the author has simply organized the results of  his research, without writing a proper introduction.</p>
      <br/>
      <p>Scrolling down, you will see the actual pyramid, with an abbreviated statement of the Situation, Complication, and Question.  We would like you to do two things:</p>
      <ol class="not-bold-list">
        <li>Write the basic simple structure for the Situation, Complication, and Question.</li>
        <li>When you are finished, take a stab at writing the full introduction in prose.  Then compare it to the School Solution.</li>
      </ol>`,
      'memo-title': `Subject: Survey of IFA Attitudes and Views`,
      'memo-description': `<p>We conducted 33 interviews with 27 firms. Our findings are as follows:</p>
      <ol>
        <li>The channel is becoming more professional, with smaller IFAs joining networks and  employing quite rigorous selection methods. IFA criteria for selecting a provider are:<br/>
          <div class="memo-wrapper">
            <div class="memo-column">
              <ul class="bullet-list">
                <li>Financial strength</li>
                <li>Investment performance</li>
                <li>Charging structure</li>
              </ul>
            </div>
          </div>
        </li>
        <li>IFAs see Thynne as an average performer, with inadequate capital:
          <ul class="bullet-list">
            <li>Investment performance is poor</li>
            <li>Products lack innovation, range not appealing</li>
            <li>Brand lacks clear message</li>
            <li>Sales force desperate for business</li>
            <li>Inconsistency in service</li>
          </ul>
        </li>
        <li>Most IFAs have little or no knowledge of AMP, don’t care who owns Thynne as long as they are financially strong.</li>
        <li>AMP needs to adopt a strategy whereby it addresses the internal problems of Thynne, while looking to bolster its own and Thynne’s standing with the community:
          <ul class="bullet-list">
            <li>Restore faith in Thynne’s financial stability and investment performance
              <ul class="bullet-list level2">
                <li>Communicate clearly about the capital support being provided</li>
                <li>Highlight the strong fund management</li>
              </ul>
            </li>
            <li>Resolve Thynne’s serious service and administrative problems</li>
            <li>Address both Thynne’s and AMP’s image in the marketplace
              <ul class="bullet-list level2">
                <li>Underline AMP’s size, strength, commitment to the UK market</li>
                <li>Describe its intentions/aspirations for Thynne</li>
              </ul>
            </li>
            <li>Successfully cultivate IFAs to restore Thynne to their panels
              <ul class="bullet-list level2">
                <li>Stress the commitment of both AMP and Thynne to the channel</li>
              </ul>
            </li>
          </ul>
        </li>
      </ol>`,
    },
    'congratulation-message': 'well done again',
    'finish-section': 'You have completed Section 4B-2',
    'final-description': 'You know how to see the structure beneath the wording of an introduction',
    'next-course-button': 'proceed to section 4C-1',
    'dashboard-button': 'Main menu',
  }
}




// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/en.js